import React, { useEffect, useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { useChangeTemplateBulk, useGetTemplates } from './hooks';
import { sortDropdownOptions } from '../utils';

export const SwitchTemplatePopUp = ({ documentIds, clientID, vendorID, categoryID, setIsOpened }) => {
	const get_templates_hook = useGetTemplates(clientID, vendorID, categoryID)
	const change_template_bulk_hook = useChangeTemplateBulk(setIsOpened)
	const [templates, settemplates] = useState([])
	const [selectedTemplate, setselectedTemplate] = useState('')

	useEffect(() => {
		if (get_templates_hook.data) {
			const options = sortDropdownOptions(get_templates_hook.data?.data).filter(
				(template) => template !== 'All'
			)
			settemplates(options)
		}
	}, [get_templates_hook.data, get_templates_hook.isSuccess, get_templates_hook.isError])

	function saveChanges() {
		if (!selectedTemplate) {
			return
		}
		change_template_bulk_hook.mutate({
			document_ids: documentIds,
			new_template: Number(selectedTemplate),
		})
	}

	return (
		<>
			<div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
				<div className="relative my-6 mx-auto w-auto lg:w-[800px]">
					<div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none z-[999]">
						<div className="p-5 rounded-t">
							<h3 className="text-2xl m-0 font-semibold text-primary text-center">
								Switch Template
							</h3>
							<button
								className="bg-transparent border-0 text-slate-400 leading-none font-semibold outline-none focus:outline-none absolute top-4 right-5"
								onClick={() => setIsOpened(false)}
								title="Close"
							>
								<span className="material-icons-outlined modalClose">
									cancel
								</span>
							</button>
						</div>
						<div className="relative pb-8 px-6 lg:w-[400px] mx-auto">
							<div className="py-2">
								<TextField
									select
									disabled={templates.length === 0}
									id="bulk-switch-templates"
									label="Templates"
									variant="outlined"
									fullWidth
									value={selectedTemplate}
									onChange={(e) => setselectedTemplate(e.target.value)}
									InputLabelProps={{
										shrink: true,
									}}
									SelectProps={{
										displayEmpty: true,
									}}
								>
									<MenuItem value="">
										<em>Select template</em>
									</MenuItem>
									{templates.map((template) => (
										<MenuItem key={template} value={String(template)}>
											{template}
										</MenuItem>
									))}
								</TextField>
								<div className="pt-4">
									<button
										type="button"
										disabled={change_template_bulk_hook.isPending || !selectedTemplate}
										onClick={saveChanges}
										className="bg-blue-800 hover:bg-indigo-700 px-8 py-3 rounded-md text-white text-sm flex w-full items-center justify-center font-black disabled:bg-gray-400"
									>
										Save
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="opacity-75 fixed inset-0 z-40 bg-black"></div>
		</>
	);
};
